import { IRootState } from '../../../store'
import { IRescueOptionsState } from '../store/options.types'

export const getRescueOptionsSelector = (state: IRootState): IRescueOptionsState => state.options.rescueOptions
